module.exports = __webpack_public_path__ + "img/Hyrma.158f431e.svg";